export const ProPill = () => (
  <span className="bg-alpineTeal w-[35px] h-[20px] rounded-[7px] flex items-center justify-center text-white text-xs font-semibold">
    PRO
  </span>
);
